module.exports = __webpack_public_path__ + "img/venn-diagram-card.6a4585e4.svg";